RivalIQ.apps.Analyze.module('views', function (views, App, Backbone, Marionette, $, _, sortable) {

    'use strict';

    views.ReorderModal = Marionette.CompositeView.mixin({
        template: '#analyzeReorderModalTemplate',
        ui: {
            modal: '.modal'
        },
        events: {
            'click .btn-primary': 'onSaveClicked'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        childViewContainer: 'ul',
        childView: views.ReorderItem,
        childViewOptions: function (model, index) {
            const me = this;
            const serializedModel = model.toJSON();
            return {
                index: index,
                hide: !me.options.filteredCollection.some(function (candidate) {
                    return _.isEqual(serializedModel, candidate.toJSON());
                })
            };
        },
        onShow: function () {
            const me = this;

            me.ui.modal.modal({
                backdrop: 'static'
            });
            sortable(me.$(me.childViewContainer));
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.FavoritesReorderOpen);
        },
        onSaveClicked: function () {
            const me = this;

            const order = me.$childViewContainer.find('li').map(function (arr, e) {
                return $(e).data('index');
            });

            me.ui.modal.modal('hide');
            me.dashboardModel.reorderDefinitions(order);
        }
    });

}, window.sortable);
